import { render, staticRenderFns } from "./beauty.vue?vue&type=template&id=70dfe85c&scoped=true&"
import script from "./beauty.vue?vue&type=script&lang=js&"
export * from "./beauty.vue?vue&type=script&lang=js&"
import style0 from "./beauty.vue?vue&type=style&index=0&lang=css&"
import style1 from "./beauty.vue?vue&type=style&index=1&id=70dfe85c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dfe85c",
  null
  
)

export default component.exports